import { Text } from './text';
import type { PropertyCodeProps } from '../../types/property-code.type';
import { formatPropertyCode } from '../../utils/catalog/property-code.util';

/** Render the backend-selected code; only Comos fallbacks carry the isotype. */
export function PropertyCode(props: PropertyCodeProps) {
  if (props.loading && !props.displayCode) {
    return (
      <span
        aria-busy="true"
        className="inline-block h-[0.8em] w-[5ch] animate-pulse rounded bg-neutral-200 align-baseline"
      />
    );
  }
  if (!props.displayCode?.isFallback) return <>{formatPropertyCode(props)}</>;
  return (
    <Text
      as="span"
      style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: '5px',
        whiteSpace: 'nowrap',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
      }}
      disableAutoLink
    >
      <img
        src="/logos/icon-inline.svg"
        alt="Comos"
        width={12.08}
        height={10}
        className="w-auto shrink-0"
        style={{ height: '0.7142857143em' }}
      />
      {props.displayCode.value}
    </Text>
  );
}
